// [목적] 회원 탈퇴 mutation 훅 — DELETE /users/me + 성공 시 로그아웃 처리
// [이유] fe-be-gap-tier3 T13(ADR-T3-4/-5) — DeleteAccountScreen 실 탈퇴 플로우 활성화.
//         useMutation → deleteMe() → 성공 시 window.location.href='/login'(전체 reload).
//         useAuth.logout() 과 동일한 패턴: SPA navigate 대신 window.location.href 로 React 트리 완전 초기화.
//         2026-09-18(L-7) — 탈퇴 성공 경로에도 SW 폴리오 캐시 정리가 없었다(로그아웃 버튼 경로에만 존재) →
//           clearUserCaches() 공용 헬퍼 호출 추가.
// [사이드 이팩트] 성공 후 모든 React 상태 / QueryClient 캐시 / AuthProvider observer 초기화됨.
//                 clearAnonSessionId() 호출 — anon 세션 ID 정리(logout 패턴 동일).
//                 clearUserCaches() 호출 — SW 폴리오 상세 캐시(-folio) 정리(공용 기기 보호).
// [수정 시 고려사항] BE 실패(401/403/500) 시 onError 를 통해 컴포넌트에서 에러 처리.
//                   CSRF 헤더는 http.ts fetchWithEnvelope 가 자동 첨부 — 별도 처리 불필요.

import { useMutation } from '@tanstack/react-query';
import { deleteMe } from '../api/user.client.js';
import { clearAnonSessionId } from '../api/anonSession.js';
import { clearUserCaches } from '../utils/clearUserCaches.js';

/**
 * [목적] 회원 탈퇴 mutation — 성공 시 세션 초기화 + /login reload
 * [이유] fe-be-gap-tier3 T13 — DeleteAccountScreen 에서 확인 단계 완료 후 호출.
 *         성공 → clearAnonSessionId + clearUserCaches(L-7) + window.location.href='/login'
 *         (useAuth.logout 패턴 동일). 실패 → ApiError throw → 컴포넌트 onError 에서 Toast 처리.
 * [사이드 이팩트] onSuccess 에서 window.location.href 할당으로 페이지 전체 리셋.
 *                 BE 가 탈퇴 성공 응답과 함께 인증 쿠키(gw_at/gw_rt/gw_csrf) 를 삭제하므로
 *                 /login 으로 이동 후 guest 상태로 정상 렌더됨.
 * [수정 시 고려사항] throttle/debounce 불필요 — 확인 단계(confirm gate)가 FE 에서 보장됨.
 */
export function useDeleteAccount() {
  return useMutation({
    mutationFn: () => deleteMe(),
    onSuccess: async () => {
      clearAnonSessionId();
      await clearUserCaches();
      window.location.href = '/login';
    },
  });
}
